import React from "react";
import * as Yup from "yup";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import mainPageService from "../../../services/main-page.service";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
const initialValues = { title: "", destinationURL: "", image: "", name: "", comment: "" };
const schema = Yup.object().shape({ destinationURL: yupSchema.destinationURL, image: yupSchema.image });
const cardForm = [{ _type: "textField", name: "title", label: "عنوان" }, { _type: "textField", name: "destinationURL", label: "آدرس مقصد" }, { _type: "filePicker", name: "image", label: "عکس", isImage: true }];
const commentForm = [{ _type: "textField", name: "name", label: "نام کاربر" }, { _type: "textField", name: "comment", label: "نظر", multiline: true, rows: 4 }];
export default function MainPageContentForm({ close, data, parent }) {
  const errorHandler = useErrorHandler();
  const handleSubmit = async (model, { setSubmitting }) => {
    if (parent.type !== "userComments" && !model.title?.trim()) model.title = " ";
    const result = data?.id ? await mainPageService.editContent(parent.id, data.index, model) : await mainPageService.createContent(parent.id, model);
    setSubmitting(false); if (result.error) return errorHandler(result.error); close(true);
  };
  return <DialogFormBuilder {...{ close, name: parent.type === "userComments" ? "نظر کاربر" : "محتوا", data, schema, initialValues, handleSubmit, form: parent.type === "userComments" ? commentForm : cardForm }} />;
}
